export default function isOpenGymLevel(level: string) {
  return level === 'OPEN_GYM';
}
